import React from 'react';

function SideBar(props) {
	return (
		<nav className="p-sticky t-10 d-none--xs">
			{props.children}
		</nav>
	)
}

export default SideBar;
